import React, { useEffect, useState } from "react";
import { api, formatErr } from "../../api";
import { SectionTitle, EmptyState, StatusPill } from "../../components/Atoms";
import { WarningCircle, Plus } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ClientIssuesPage() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ subject:"", description:"" });

  const load = async () => { const { data } = await api.get("/issues"); setList(data); };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try { await api.post("/issues", form); toast.success("Issue raised"); setOpen(false); setForm({ subject:"", description:"" }); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div className="space-y-5">
      <SectionTitle title="Issues" subtitle="Raise concerns about creators or submissions"
        action={<button onClick={() => setOpen(true)} className="btn-primary flex items-center gap-2"><Plus size={16} weight="bold" /> New</button>} />
      {list.length === 0 ? <EmptyState icon={WarningCircle} title="All clear" subtitle="No open issues yet." /> : (
        <div className="grid sm:grid-cols-2 gap-4">
          {list.map(i => (
            <div key={i.id} className="glass p-4 hover-lift">
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="text-white font-bold">{i.subject}</div>
                <StatusPill status={i.status} />
              </div>
              <div className="text-sm text-muted">{i.description}</div>
            </div>
          ))}
        </div>
      )}
      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4" onClick={() => setOpen(false)}>
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
          <form onSubmit={save} className="glass relative p-6 w-full max-w-md max-h-[90vh] overflow-y-auto space-y-3" onClick={e => e.stopPropagation()}>
            <div className="text-white text-xl font-bold">Raise an Issue</div>
            <input required placeholder="Subject" value={form.subject} onChange={e => setForm({...form, subject:e.target.value})} className="input-base" />
            <textarea required rows={4} placeholder="Describe the issue" value={form.description} onChange={e => setForm({...form, description:e.target.value})} className="input-base" />
            <div className="flex gap-2">
              <button type="button" onClick={() => setOpen(false)} className="btn-ghost flex-1">Cancel</button>
              <button type="submit" className="btn-primary flex-1">Submit</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
